import ReactQuill from 'react-quill';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';

import 'react-quill/dist/quill.bubble.css';

const IntroductionSurvey = ({
  isEnabledIntroduction,
  setIsEnabledIntroduction,
  introductionText,
  setIntroductionText,
}) => {
  const handleSwitchChange = (event) => {
    setIsEnabledIntroduction(event.target.checked);
  };

  const handleTextChange = (value) => {
    setIntroductionText(value);
  };

  return (
    <Box
      sx={{
        marginTop: 2,
        '& .quill': {
          backgroundColor: 'white',
          borderRadius: '8px',
          border: '1px solid #d1d5db', // 👈 BORDE
        },
        '& .ql-container': {
          minHeight: '200px',
          fontSize: '14px',
          border: 'none', // 👈 evita doble borde
        },
        '& .ql-editor': {
          minHeight: '120px', // altura mínima
          maxHeight: '200px', // 👈 LÍMITE
          overflowY: 'auto', // 👈 SCROLL VERTICAL
          padding: '12px',
        },
        '& .quill:hover': {
          borderColor: '#9ca3af', // hover
        },
        '& .quill:focus-within': {
          borderColor: 'primary.main', // focus (azul)
          boxShadow: '0 0 0 1px primary.main',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#1f2937' }}>
          Introducción de la encuesta
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <Typography variant="body1" sx={{ color: '#6b7280' }}>
          ¿Desea habilitar una introducción para esta encuesta?
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={isEnabledIntroduction}
              onChange={handleSwitchChange}
              color="primary"
            />
          }
          label={isEnabledIntroduction}
          sx={{ ml: 1 }}
        />
      </Box>

      {isEnabledIntroduction && (
        <Box
          sx={{
            marginTop: 2,
            '& .quill': {
              backgroundColor: 'white',
              borderRadius: 1,
            },
            '& .ql-container': {
              minHeight: '200px',
              fontSize: '14px',
            },
            '& .ql-editor': {
              minHeight: '200px',
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{ mb: 1, color: '#374151', fontWeight: 500 }}
          >
            Contenido de la introducción:
          </Typography>
          <ReactQuill
            value={introductionText}
            onChange={handleTextChange}
            theme="snow"
            placeholder="Escribe aquí la introducción que verán los usuarios al comenzar la encuesta..."
            modules={{
              toolbar: [
                [{ header: [1, 2, 3, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ color: [] }, { background: [] }],
                ['link'],
                ['clean'],
              ],
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default IntroductionSurvey;
